import { Box, Chip, Tab, Tabs, tabsClasses } from "@mui/material";

import type { SyntheticEvent } from "react";
import type { CarrierCommentDocument } from "./buildCommentDocument";

interface CarrierTabBarProps {
  carriers: readonly CarrierCommentDocument[];
  activeCarrierId: string;
  onChange: (carrierId: string) => void;
}

/** Carrier tabs, each labeled with its own comment count — the drawer shows
 * one carrier's comments at a time (AC). */
const CarrierTabBar = ({
  carriers,
  activeCarrierId,
  onChange,
}: CarrierTabBarProps): React.JSX.Element => {
  const handleChange = (_: SyntheticEvent, value: string): void =>
    onChange(value);

  return (
    <Tabs
      data-testid="needs-review-comments-carrier-tabs"
      value={activeCarrierId}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons={false}
      aria-label="Carrier comments tabs"
      textColor="secondary"
      indicatorColor="secondary"
      sx={{
        height: 48,
        borderBottom: 1,
        borderColor: "divider",
        px: 2,
        [`& .${tabsClasses.indicator}`]: {
          height: 2,
          backgroundColor: "brandPrimary.main",
        },
        "& .MuiTab-root.Mui-selected": { color: "brandPrimary.main" },
        [`& .${tabsClasses.scrollButtons}`]: {
          "&.Mui-disabled": { opacity: 0.3 },
        },
      }}
    >
      {carriers.map((carrier) => (
        <Tab
          key={carrier.carrierId}
          value={carrier.carrierId}
          data-testid={`needs-review-comments-carrier-tab-${carrier.carrierId}`}
          sx={{
            // py: 1,
            textTransform: "uppercase",
            "&.MuiButtonBase-root": {
              fontSize: "0.875rem",
              fontWeight: 500,
            },
          }}
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {carrier.carrierName}
              <Chip
                label={carrier.count}
                size="small"
                color="brandPrimary"
                sx={{ minWidth: 25, fontSize: "0.7rem", borderRadius: 1 }}
              />
            </Box>
          }
        />
      ))}
    </Tabs>
  );
};

export default CarrierTabBar;
